import { Component, ElementRef, Input, OnChanges, SimpleChanges, ViewChild } from '@angular/core';
import DOMPurify from 'dompurify';

@Component({
  selector: 'embed-html',
  templateUrl: './embed-html.component.html',
  styleUrls: [ './embed-html.component.scss' ]
})
export class EmbedHtmlComponent implements OnChanges {

  @ViewChild('iframe', { static: true })
  iframe: ElementRef;

  @Input() html: string = '';
  @Input() customWidth: string = '100%';
  @Input() customHeight: string = '100%';

  id: string = Math.random().toString(36).substr(2, 9);

  ngOnChanges(changes: SimpleChanges): void {
    this.setHtml(changes.html.currentValue);
  }

  setHtml(html: string): void {
    this.iframe.nativeElement.contentWindow.document.body.innerHTML = DOMPurify.sanitize(html);
  }
}
